import { Injectable } from "@angular/core";
import { environment } from "../../../../../environments/environment";
import { layers as layersConfig } from "../map-configuration";
import { IMapLayer } from "../map.settings";

// interimn-mapper arcgis 3.x -> arcgis 4.x
@Injectable({
    providedIn: "root"
})
export class LayerMapperService {
    getLayer(rasklayer: IMapLayer) {
        switch (rasklayer.id) {
            case "metriabakgrund":
                return {
                    url: environment.basemapLayers.metriabakgrund.baseMapLayers[0].url,
                    id: rasklayer.id,
                    name: environment.basemapLayers.metriabakgrund.title,
                    visible: rasklayer.visible,
                    thumbnailUrl: environment.basemapLayers.metriabakgrund.thumbnailUrl
                };
            case "metriaorto":
                return {
                    url: environment.basemapLayers.metriaorto.baseMapLayers[0].url,
                    id: rasklayer.id,
                    name: environment.basemapLayers.metriaorto.title,
                    visible: rasklayer.visible,
                    thumbnailUrl: environment.basemapLayers.metriaorto.thumbnailUrl
                };
            default: {
                const layers = environment.dynamicFeatureLayers.filter(x => x.id === rasklayer.id);
                if (!layers || layers.length === 0) {
                    console.error(`layer not found: ${rasklayer.id}`);
                }
                const layersettings = layersConfig[layers[0].id];
                const layer = layers[0];
                return {
                    id: layer.id,
                    url: layer.url,
                    name: layer.name,
                    visible: rasklayer.visible,
                    minScale: rasklayer.minScale ?? 0,
                    maxScale: rasklayer.maxScale ?? 0,
                    opacity: layer.opacity,
                    layerType: layer.layerType,
                    hideInLayerList: rasklayer.hideInLayerList,
                    services: layersettings?.services ?? [{ id: layer.id }]
                };
            }
        }
    }
}
